import { Folder, LocalOfferSharp, MonetizationOn, People, PhotoLibrary, Policy, Settings } from '@material-ui/icons';
import { Admin, Login, Resource } from 'react-admin';

import { ContentCreate, ContentEdit, ContentList } from './contents-forms';
import { MediaCreate, MediaEdit, MediaList } from './media-forms';
import { TypesCreate, TypesEdit, TypesList } from './types-forms';

import authProvider from 'auth-provider';
import dataProvider from 'data-provider';
import { AdministratorCreate, AdministratorEdit, AdministratorList } from './administrators-forms';
import LoginForm from './login-form';
import { QuoteRequestList, QuoteRequestShow } from './quote-requests-forms';
import { SettingCreate, SettingEdit, SettingList } from './settings-forms';
import { UsersCreate, UsersEdit, UsersList } from './users-forms';

const AppLoginForm = () => (
    <Login>
        <LoginForm />
    </Login>
)

const App = () => (
    <Admin
        authProvider={authProvider}
        dataProvider={dataProvider}
        loginPage={AppLoginForm}
    >
        <Resource
            name='quote-requests'
            options={{
                label: 'Quote Requests'
            }}
            icon={MonetizationOn}
            list={QuoteRequestList}
            show={QuoteRequestShow}
            hasEdit={false}
        />

        <Resource name='administrators'
            icon={Policy}
            options={{
                label: 'Administrators',
            }}
            list={AdministratorList}
            edit={AdministratorEdit}
            create={AdministratorCreate}
        />

        <Resource name='users'
            icon={People}
            options={{
                label: 'Users',
            }}
            list={UsersList}
            edit={UsersEdit}
            create={UsersCreate}
        />

        <Resource name='settings'
            icon={Settings}
            list={SettingList}
            edit={SettingEdit}
            create={SettingCreate}
        />

        <Resource
            name='contents'
            icon={Folder}
            list={ContentList}
            edit={ContentEdit}
            create={ContentCreate}
        />

        <Resource name='types'
            icon={LocalOfferSharp}
            list={TypesList}
            edit={TypesEdit}
            create={TypesCreate}
        />

        <Resource
            name='media'
            icon={PhotoLibrary}
            list={MediaList}
            edit={MediaEdit}
            create={MediaCreate}
        />

    </Admin>
);

export default App;
